import { render, staticRenderFns } from "./spacer.vue?vue&type=template&id=71291c62&scoped=true&lang=pug&"
import script from "./spacer.vue?vue&type=script&lang=js&"
export * from "./spacer.vue?vue&type=script&lang=js&"
import style0 from "./spacer.styl?vue&type=style&index=0&id=71291c62&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71291c62",
  null
  
)

export default component.exports